import styled from "styled-components";

const fillURL = new URL("../../assets/fill.svg", import.meta.url);

export default styled.div`
    background: radial-gradient(circle at 66% 33%, rgba(0,0,0,0.03) 10%, rgba(0,0,0,0) 60%);
    mask: url(${ fillURL });
    mask-position: 0 0;
    mask-size: 100%;
`;
